import { Component, OnInit } from '@angular/core';
import { fadeInOnEnterAnimation, fadeOutOnLeaveAnimation } from 'angular-animations';
import { Router } from '@angular/router';

@Component({
  templateUrl: './multiple-vehicle-info.component.html',
  styleUrls: ['./multiple-vehicle-info.component.scss'],
  animations: [
    fadeInOnEnterAnimation(),
    fadeOutOnLeaveAnimation()
  ],
})
export class MultipleVehicleInfoComponent implements OnInit {

  constructor(
    private router: Router,
  ) { }

  ngOnInit(): void {
  }

  onContinue() {
    this.router.navigate(['/account/review-plan']);
  }

}
